<template>
  <div class="shape-picker-wrapper">
    <field-option-customer-info-input
      readonly
      ref="input-item"
      placeholder="请选择种类"
      @click.native="toggleShapePicker"
    >
      <template v-if="shape" slot="right"> ￥{{ shape.price }} </template>
    </field-option-customer-info-input>
    <van-popup v-model="isShapePickerShown" position="bottom">
      <van-radio-group v-model="value">
        <van-cell-group>
          <van-cell
            v-for="item of items.filter(item => item.mobile)"
            :key="item.value"
            :title="item.text"
            clickable
            @click="() => handleCellClick(item.value)"
          >
            <template slot="right-icon">
              <van-radio :name="item.value" />
            </template>
            <div class="price-wrapper">
              <span class="price">￥{{ item.price }}</span>
            </div>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-popup>
  </div>
</template>
<script>
import FieldOptionCustomerInfoInput from './FieldOptionCustomerInfoInput.vue';

export default {
  components: {
    FieldOptionCustomerInfoInput,
  },
  props: {
    items: [Array],
  },
  data() {
    return {
      value: undefined,
      isShapePickerShown: false,
    };
  },
  computed: {
    shape() {
      return this.items.find(item => item.value === this.value);
    },
  },
  watch: {
    value() {
      this.$refs['input-item'].setValue(this.shape.text);
      this.$emit('change', this.shape);
    },
  },
  methods: {
    toggleShapePicker() {
      this.isShapePickerShown = !this.isShapePickerShown;
    },
    handleCellClick(val) {
      this.value = val;
      this.toggleShapePicker();
    },
  },
};
</script>
<style lang="less" scoped>
.shape-picker-wrapper {
  .price-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    color: #faad14;
    margin-right: 8px;
  }
}
</style>
